import Query from '../../components/Report';

const query = ({ page = '' }) => new Query('discover-page-card', { page });

export default query;
